<div class="row shadow p-4 mb-5 bg-white rounded mt-3 monitor-dashboard-chart-card">
  <div class="col-12">
    <div class="d-flex align-items-center mb-2">
      <h5 class="mb-2 monitor-dashboard-card-title">
        <span class="monitor-dashboard-chart-title-link" @click="onTitleClick">{{ $t('monitorDashboard.requestsBySmsProviderAndSenderType') }}</span>
      </h5>
    </div>

    <div class="monitor-dashboard-chart-stage">
      <div v-show="!isLoading && hasData" class="monitor-dashboard-provider-sender-chart-scroll" :style="scrollAreaStyle">
        <div :style="innerChartWrapperStyle">
          <canvas :id="canvasId" class="monitor-dashboard-provider-sender-chart-canvas" role="img"
            :aria-label="$t('monitorDashboard.requestsBySmsProviderAndSenderType')"></canvas>
        </div>
      </div>

      <div v-if="isLoading" class="monitor-dashboard-skeleton-wrap monitor-dashboard-state-layer" role="status" aria-live="polite">
        <span class="sr-only">{{ $t('monitorDashboard.loading') }}</span>
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-block" aria-hidden="true"></div>
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-line" aria-hidden="true"></div>
      </div>

      <div v-else-if="!hasData" class="monitor-dashboard-state-block monitor-dashboard-state-layer">
        <p class="mb-0 font-weight-bold">{{ $t('monitorDashboard.noRequests')}}</p>
      </div>
    </div>
  </div>
</div>
